"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _onlineFile = require("@/api/onlineFile/onlineFile");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      minioUrl: undefined,
      outboundFile: '',
      inboundFile: ''
    };
  },
  methods: {
    /**
     * 获取在线文档链接
     */
    getTariffsDetail: function getTariffsDetail() {
      var _this = this;
      this.minioUrl = this.GLOBAL.MINIO_URL;
      var fileCode = 'OUTBOUND_DEMURRAGE';
      var fileCode1 = 'INBOUND_DEMURRAGE';
      (0, _onlineFile.getOnlineFile)([fileCode, fileCode1]).then(function (response) {
        _this.outboundFile = _this.minioUrl + response.data.filter(function (item) {
          return item.functionCode === 'OUTBOUND_DEMURRAGE';
        })[0].functionValue.split('-')[1];
        _this.inboundFile = _this.minioUrl + response.data.filter(function (item) {
          return item.functionCode === 'INBOUND_DEMURRAGE';
        })[0].functionValue.split('-')[1];
      });
    }
  },
  created: function created() {
    this.getTariffsDetail();
  }
};